const _ = require('lodash') 

export const PrepositionalCaseQuiz = _.shuffle([
  {
    word: 'Корридор',
    choices: [
      {
        name: 'Rule',
        options: [
          {
            title: 'replace the last letter with "e"',
            correct: false,
            name:'option1'
          },
          {
            title: 'add "e" to the last letter',
            correct: true,
            name:'option1'
          }
        ]
      },
      {
        name: 'Gender',
        options: [
          {
            title: 'male',
            correct: true,
            name:'option2'
          },
          {
            title: 'female',
            correct: false,
            name:'option2'
          },
          {
            title: 'neuter',
            correct: false,
            name:'option2'
          }
        ]
      }
    ]
  },
  {
    word: 'Музей',
    choices: [
      {
        name: 'Rule',
        options: [
          {
            title: 'replace the last letter with "e"',
            correct: true,
            name:'option1'
          },
          {
            title: 'add "e" to the last letter',
            correct: false,
            name:'option1'
          }
        ]
      },
      {
        name: 'Gender',
        options: [
          {
            title: 'male',
            correct: true,
            name:'option2'
          },
          {
            title: 'female',
            correct: false,
            name:'option2'
          },
          {
            title: 'neuter',
            correct: false,
            name:'option2'
          }
        ]
      }
    ]
  },
  {
    word: 'Банк',
    choices: [
      {
        name: 'Rule',
        options: [
          {
            title: 'replace the last letter with "e"',
            correct: false,
            name:'option1'
          },
          {
            title: 'add "e" to the last letter',
            correct: true,
            name:'option1'
          }
        ]
      },
      {
        name: 'Gender',
        options: [
          {
            title: 'male',
            correct: true,
            name:'option2'
          },
          {
            title: 'female',
            correct: false,
            name:'option2'
          },
          {
            title: 'neuter',
            correct: false,
            name:'option2'
          }
        ]
      }
    ]
  },
  {
    word: 'Больница',
    choices: [
      {
        name: 'Rule',
        options: [
          {
            title: 'replace the last letter with "e"',
            correct: true,
            name:'option1'
          },
          {
            title: 'add "e" to the last letter',
            correct: false,
            name:'option1'
          }
        ]
      },
      {
        name: 'Gender',
        options: [
          {
            title: 'male',
            correct: false,
            name:'option2'
          },
          {
            title: 'female',
            correct: true,
            name:'option2'
          },
          {
            title: 'neuter',
            correct: false,
            name:'option2'
          }
        ]
      }
    ]
  },
  {
    word: 'Культура',
    choices: [
      {
        name: 'Rule',
        options: [
          {
            title: 'replace the last letter with "e"',
            correct: true,
            name:'option1'
          },
          {
            title: 'add "e" to the last letter',
            correct: false,
            name:'option1'
          }
        ]
      },
      {
        name: 'Gender',
        options: [
          {
            title: 'male',
            correct: false,
            name:'option2'
          },
          {
            title: 'female',
            correct: true,
            name:'option2'
          },
          {
            title: 'neuter',
            correct: false,
            name:'option2'
          }
        ]
      }
    ]
  },
  {
    word: 'Окно',
    choices: [
      {
        name: 'Rule',
        options: [
          {
            title: 'replace the last letter with "e"',
            correct: true,
            name:'option1'
          },
          {
            title: 'add "e" to the last letter',
            correct: false,
            name:'option1'
          }
        ]
      },
      {
        name: 'Gender',
        options: [
          {
            title: 'male',
            correct: false,
            name:'option2'
          },
          {
            title: 'female',
            correct: false,
            name:'option2'
          },
          {
            title: 'neuter',
            correct: true,
            name:'option2'
          }
        ]
      }
    ]
  },
  {
    word: 'Школа',
    choices: [
      {
        name: 'Rule',
        options: [
          {
            title: 'replace the last letter with "e"',
            correct: true,
            name:'option1'
          },
          {
            title: 'add "e" to the last letter',
            correct: false,
            name:'option1'
          }
        ]
      },
      {
        name: 'Gender',
        options: [
          {
            title: 'male',
            correct: false,
            name:'option2'
          },
          {
            title: 'female',
            correct: true,
            name:'option2'
          },
          {
            title: 'neuter',
            correct: false,
            name:'option2'
          }
        ]
      }
    ]
  },
  {
    word: 'Аптека',
    choices: [
      {
        name: 'Rule',
        options: [
          {
            title: 'replace the last letter with "e"',
            correct: true,
            name:'option1'
          },
          {
            title: 'add "e" to the last letter',
            correct: false,
            name:'option1'
          }
        ]
      },
      {
        name: 'Gender',
        options: [
          {
            title: 'male',
            correct: false,
            name:'option2'
          },
          {
            title: 'female',
            correct: true,
            name:'option2'
          },
          {
            title: 'neuter',
            correct: false,
            name:'option2'
          }
        ]
      }
    ]
  },
  {
    word: 'Университет',
    choices: [
      {
        name: 'Rule',
        options: [
          {
            title: 'replace the last letter with "e"',
            correct: false,
            name:'option1'
          },
          {
            title: 'add "e" to the last letter',
            correct: true,
            name:'option1'
          }
        ]
      },
      {
        name: 'Gender',
        options: [
          {
            title: 'male',
            correct: true,
            name:'option2'
          },
          {
            title: 'female',
            correct: false,
            name:'option2'
          },
          {
            title: 'neuter',
            correct: false,
            name:'option2'
          }
        ]
      }
    ]
  },
  {
    word: 'Офис',
    choices: [
      {
        name: 'Rule',
        options: [
          {
            title: 'replace the last letter with "e"',
            correct: false,
            name:'option1'
          },
          {
            title: 'add "e" to the last letter',
            correct: true,
            name:'option1'
          }
        ]
      },
      {
        name: 'Gender',
        options: [
          {
            title: 'male',
            correct: true,
            name:'option2'
          },
          {
            title: 'female',
            correct: false,
            name:'option2'
          },
          {
            title: 'neuter',
            correct: false,
            name:'option2'
          }
        ]
      }
    ]
  }
])


export const InstrumentalCaseQuiz = _.shuffle([
  {
    word: 'Журналист',
    choices: [
      {
        name: 'Rule',
        options: [
          {
            title: 'replace the last letter with "eм"',
            correct: false,
            name:'option1'
          },
          {
            title: 'add "ом" to the last letter',
            correct: true,
            name:'option1'
          }
        ]
      },
      {
        name: 'Gender',
        options: [
          {
            title: 'male',
            correct: true,
            name:'option2'
          },
          {
            title: 'female',
            correct: false,
            name:'option2'
          },
          {
            title: 'neuter',
            correct: false,
            name:'option2'
          }
        ]
      }
    ]
  },
  {
    word: 'Профессор',
    choices: [
      {
        name: 'Rule',
        options: [
          {
            title: 'replace the last letter with "eм"',
            correct: false,
            name:'option1'
          },
          {
            title: 'add "ом" to the last letter',
            correct: true,
            name:'option1'
          }
        ]
      },
      {
        name: 'Gender',
        options: [
          {
            title: 'male',
            correct: true,
            name:'option2'
          },
          {
            title: 'female',
            correct: false,
            name:'option2'
          },
          {
            title: 'neuter',
            correct: false,
            name:'option2'
          }
        ]
      }
    ]
  },
  {
    word: 'Секретарь',
    choices: [
      {
        name: 'Rule',
        options: [
          {
            title: 'replace the last letter with "eм"',
            correct: true,
            name:'option1'
          },
          {
            title: 'add "ом" to the last letter',
            correct: false,
            name:'option1'
          }
        ]
      },
      {
        name: 'Gender',
        options: [
          {
            title: 'male',
            correct: true,
            name:'option2'
          },
          {
            title: 'female',
            correct: false,
            name:'option2'
          },
          {
            title: 'neuter',
            correct: false,
            name:'option2'
          }
        ]
      }
    ]
  },
  {
    word: 'Учитель',
    choices: [
      {
        name: 'Rule',
        options: [
          {
            title: 'replace the last letter with "eм"',
            correct: true,
            name:'option1'
          },
          {
            title: 'add "e" to the last letter',
            correct: false,
            name:'option1'
          }
        ]
      },
      {
        name: 'Gender',
        options: [
          {
            title: 'male',
            correct: true,
            name:'option2'
          },
          {
            title: 'female',
            correct: false,
            name:'option2'
          },
          {
            title: 'neuter',
            correct: false,
            name:'option2'
          }
        ]
      }
    ]
  },
  {
    word: 'Инженер',
    choices: [
      {
        name: 'Rule',
        options: [
          {
            title: 'replace the last letter with "eм"',
            correct: false,
            name:'option1'
          },
          {
            title: 'add "ом" to the last letter',
            correct: true,
            name:'option1'
          }
        ]
      },
      {
        name: 'Gender',
        options: [
          {
            title: 'male',
            correct: true,
            name:'option2'
          },
          {
            title: 'female',
            correct: false,
            name:'option2'
          },
          {
            title: 'neuter',
            correct: false,
            name:'option2'
          }
        ]
      }
    ]
  },
  {
    word: 'Пекарь (baker)',
    choices: [
      {
        name: 'Rule',
        options: [
          {
            title: 'replace the last letter with "eм"',
            correct: true,
            name:'option1'
          },
          {
            title: 'add "ом" to the last letter',
            correct: false,
            name:'option1'
          }
        ]
      },
      {
        name: 'Gender',
        options: [
          {
            title: 'male',
            correct: true,
            name:'option2'
          },
          {
            title: 'female',
            correct: false,
            name:'option2'
          },
          {
            title: 'neuter',
            correct: false,
            name:'option2'
          }
        ]
      }
    ]
  },
  {
    word: 'Швея (seamstress)',
    choices: [
      {
        name: 'Rule',
        options: [
          {
            title: 'replace the last letter with "eй"',
            correct: true,
            name:'option1'
          },
          {
            title: 'add "ю" to the last letter',
            correct: false,
            name:'option1'
          }
        ]
      },
      {
        name: 'Gender',
        options: [
          {
            title: 'male',
            correct: false,
            name:'option2'
          },
          {
            title: 'female',
            correct: true,
            name:'option2'
          },
          {
            title: 'neuter',
            correct: false,
            name:'option2'
          }
        ]
      }
    ]
  },
  {
    word: 'Библиотекарь (Librarian)',
    choices: [
      {
        name: 'Rule',
        options: [
          {
            title: 'replace the last letter with "ем"',
            correct: true,
            name:'option1'
          },
          {
            title: 'add "eм" to the last letter',
            correct: false,
            name:'option1'
          }
        ]
      },
      {
        name: 'Gender',
        options: [
          {
            title: 'male',
            correct: true,
            name:'option2'
          },
          {
            title: 'female',
            correct: false,
            name:'option2'
          },
          {
            title: 'neuter',
            correct: false,
            name:'option2'
          }
        ]
      }
    ]
  },
  {
    word: 'Доктор',
    choices: [
      {
        name: 'Rule',
        options: [
          {
            title: 'replace the last letter with "eм"',
            correct: false,
            name:'option1'
          },
          {
            title: 'add "ом" to the last letter',
            correct: true,
            name:'option1'
          }
        ]
      },
      {
        name: 'Gender',
        options: [
          {
            title: 'male',
            correct: true,
            name:'option2'
          },
          {
            title: 'female',
            correct: false,
            name:'option2'
          },
          {
            title: 'neuter',
            correct: false,
            name:'option2'
          }
        ]
      }
    ]
  },
  {
    word: 'Стюардесса (Stewardess)',
    choices: [
      {
        name: 'Rule',
        options: [
          {
            title: 'replace the last letter with "ой"',
            correct: true,
            name:'option1'
          },
          {
            title: 'add "ей" to the last letter',
            correct: false,
            name:'option1'
          }
        ]
      },
      {
        name: 'Gender',
        options: [
          {
            title: 'male',
            correct: false,
            name:'option2'
          },
          {
            title: 'female',
            correct: true,
            name:'option2'
          },
          {
            title: 'neuter',
            correct: false,
            name:'option2'
          }
        ]
      }
    ]
  }
])